<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder container" >
      <!-- 1 -->
      <b-card-header class="custom-header">
        <b-row>
          <b-col>
            <div>
              <i class="icon-grid"></i>&nbsp;Dashboard
            </div>
          </b-col>
          <b-col>
            <b-dropdown variant="primary mr-1" right text="Save" style="float: right">
              <b-dropdown-item href="#">
                <i class="fa fa-cloud-download mr-1">&nbsp;Export</i>
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="fa fa-plus mr-1">&nbsp;Add widget</i>
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="fa fa-cloud-upload mr-1">&nbsp;import</i>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-card-header>
      <!-- 1 -->
      <!-- <b-card-header class="custom-header">
        <b-row>
          <b-col>
            <div>
              <i class="icon-grid"></i>&nbsp;Dashboard
            </div>
          </b-col>
          <b-col>
            <b-dropdown variant="primary mr-1" right text="Save" style="float: right">
              <b-dropdown-item href="#">
                <i class="fa fa-cloud-download mr-1">&nbsp;Export</i>
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="fa fa-plus mr-1">&nbsp;Add widget</i>
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="fa fa-cloud-upload mr-1">&nbsp;import</i>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-card-header>
      <br /> -->

      <div class="container">
        <div class="row component-container">
          <b-col class="col-md-12 component-section">
            <div class="panel panel-default">
              <div class="panel">
              <!-- 6 -->
              <!-- Line Chart : Contacts created-->
              <b-row>
                <b-container class="column component-section">
                  <b-card no-body class="panel panel-default panel-body">
                    <b-card-body class="panel clearfix">
                      <b-col sm="4">
                        <h4 id="traffic" class="card-title mb-0">Contacts created</h4>
                        <div class="small text-muted">November 2017</div>
                      </b-col>

                      <b-col sm="8" class="d-md-block d-md-block">
                        <b-dropdown block variant="white" class="btn-square" style="float: right" no-caret>
                        <template slot="button-content" sm="lg">
                          <span class="fa fa-ellipsis-v"></span>
                        </template>
                        <b-dropdown-item-button>
                          <i class="fa fa-pencil">&nbsp;Edit</i>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button>
                          <i class="fa fa-remove">&nbsp;Remove</i>
                        </b-dropdown-item-button>
                      </b-dropdown>
                      <b-button type="button" variant="primary" class="float-right">
                        <i class="icon-cloud-download"></i>
                      </b-button>
                      <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                        <b-form-radio-group
                          class="mr-3"
                          id="radiosBtn"
                          buttons
                          button-variant="outline-secondary"
                          v-model="selected"
                          name="radiosBtn"
                        >
                        <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
                        <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
                        <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
                        </b-form-radio-group>
                      </b-button-toolbar>
                    </b-col>
                  </b-card-body>
                  <!-- Line Chart -->
                  <main-chart-example
                    chartId="main-chart-01"
                    class="chart-wrapper"
                    style="height:300px;margin-top:40px;"
                    height="300"
                  ></main-chart-example>
                </b-card>
               </b-container>   
              </b-row>
              </div>    
            </div>
          </b-col>

          <b-col class="col-8 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <b-row class="row">
                <!-- 7 -->
                  <b-col cols="12">
                  <!-- Map Chart -> https://github.com/highcharts/highcharts-vue -->
                    <b-card header>
                      <b-dropdown block variant="white" class="btn-square" style="float: right" no-caret>
                        <template slot="button-content" sm="lg">
                          <span class="fa fa-ellipsis-v"></span>
                        </template>
                        <b-dropdown-item-button>
                          <i class="fa fa-pencil">&nbsp;Edit</i>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button>
                          <i class="fa fa-remove">&nbsp;Remove</i>
                        </b-dropdown-item-button>
                      </b-dropdown>
                      <div class="chart-wrapper">
                        <mapChart style="height: 100px"></mapChart>
                      </div>
                    </b-card>
                  </b-col>
                </b-row>
              </div>    
            </div>
          </b-col>
          <b-col class="col-4 component-section">
            <div class="panel panel-default">
              <div class="panel">
                  <!-- 8 -->
                  <b-col cols="12">
                    <b-card class="topListsTable">
                      <div class="chart-wrapper">
                        <b-row>
                          <b-col>
                            <h4 id="topLists" class="card-title mb-0">Top lists</h4>
                          </b-col>
                          <b-col>
                            <b-dropdown
                              block
                              variant="white"
                              class="btn-square"
                              style="float: right"
                              no-caret
                            >
                            <template slot="button-content" sm="lg">
                              <span class="fa fa-ellipsis-v"></span>
                            </template>
                            <b-dropdown-item-button>
                              <i class="fa fa-pencil">&nbsp;Edit</i>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button>
                              <i class="fa fa-remove">&nbsp;Remove</i>
                            </b-dropdown-item-button>
                          </b-dropdown>
                          </b-col>
                        </b-row>
                        <!-- Top Lists Table -->
                        <b-row height="300">
                          <b-col>
                            <b-table hover :items="topLists"></b-table>
                          </b-col>
                        </b-row>
                      </div>
                    </b-card>
                  </b-col>
              </div>    
            </div>
          </b-col>

          <b-col class="col-md-12 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <!-- 9 -->
                <!-- Line Chart : Visits-->
                <b-row>
                  <b-container class="column component-section">
                    <b-card no-body class="panel panel-default panel-body">
                      <b-card-body class="panel clearfix">
                        <b-col sm="4">
                          <h4 id="visits" class="card-title mb-0">Visits</h4>
                        </b-col>
                        <b-col sm="8" class="d-none d-md-block">
                          <b-dropdown block variant="white" class="btn-square" style="float: right" no-caret>
                            <template slot="button-content" sm="lg">
                              <span class="fa fa-ellipsis-v"></span>
                            </template>
                            <b-dropdown-item-button>
                              <i class="fa fa-pencil">&nbsp;Edit</i>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button>
                              <i class="fa fa-remove">&nbsp;Remove</i>
                            </b-dropdown-item-button>
                          </b-dropdown>
                        </b-col>
                      </b-card-body>
                      <!-- Line Chart -->
                      <main-chart-example
                        chartId="main-chart-01"
                        class="chart-wrapper"
                        style="height:300px;margin-top:40px;"
                        height="300"
                      ></main-chart-example>
                    </b-card>
                  </b-container>   
                </b-row>
              </div>    
            </div>
          </b-col>

          <b-col class="col-md-12 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <!-- 10 -->
                <!-- Line Chart : Emails sent / opened-->
                <b-row>
                  <b-container class="column component-section">
                    <b-card no-body class="panel panel-default panel-body">
                      <b-card-body class="panel clearfix">
                        <b-col sm="4">
                          <h4 id="emailsSent" class="card-title mb-0">Emails sent / opened</h4>
                        </b-col>
                        <b-col sm="8" class="d-none d-md-block">
                          <b-dropdown block variant="white" class="btn-square" style="float: right" no-caret>
                            <template slot="button-content" sm="lg">
                              <span class="fa fa-ellipsis-v"></span>
                            </template>
                            <b-dropdown-item-button>
                              <i class="fa fa-pencil">&nbsp;Edit</i>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button>
                              <i class="fa fa-remove">&nbsp;Remove</i>
                            </b-dropdown-item-button>
                          </b-dropdown>
                        </b-col>
                      </b-card-body>
                      <!-- Line Chart -->
                      <main-chart-example
                        chartId="main-chart-01"
                        class="chart-wrapper"
                        style="height:300px;margin-top:40px;"
                        height="300"
                      ></main-chart-example>
                      </b-card>
                    </b-container>   
                  </b-row>
                </div>    
              </div>
            </b-col>

            <b-col class="col-3 component-section">
              <div class="panel panel-default">
                <div class="panel">
                  <b-row>
                    <!-- 11 -->
                    <b-col sm="12" id="pieChart" class="column">
                      <b-card header="Unique/returning visitors" class="textPieChart">
                        <pie-example chartId="chart-pie-01" class="chart-wrapper"></pie-example>
                      </b-card>
                    </b-col>
                  </b-row>
              </div>    
            </div>
          </b-col>
          <b-col class="col-3 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <b-row>
                  <!-- 12 -->
                  <b-col sm="12" id="pieChart" class="column">
                    <b-card header="Ignored/opened emails" class="textPieChart">
                      <pie-example chartId="chart-pie-01" class="chart-wrapper"></pie-example>
                    </b-card>
                  </b-col>
                </b-row>
              </div>    
            </div>
          </b-col>
          <b-col class="col-3 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <b-row>
                  <!-- 13 -->
                  <b-col sm="12" id="pieChart" class="column">
                    <b-card header="Identified vs anonymous leads" class="textPieChart">
                      <pie-example chartId="chart-pie-01" class="chart-wrapper"></pie-example>
                    </b-card>
                  </b-col>
                </b-row>
              </div>    
            </div>
          </b-col>
          <b-col class="col-3 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <b-row>
                  <!-- 14 -->
                  <b-col sm="12" id="pieChart" class="column">
                    <b-card header="Identified vs anonymous leads" class="textPieChart">
                      <pie-example chartId="chart-pie-01" class="chart-wrapper"></pie-example>
                    </b-card>
                  </b-col>
                </b-row>
              </div>    
            </div>
          </b-col>

          <b-col class="col-md-12 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <!-- 15 -->
               <b-row class="row">
                  <b-container class="column component-section">
                    <b-card no-body class="panel panel-default panel-body" header="Traffic &amp; Sales">
                      <b-card-body class="panel clearfix">
                      <!-- <b-col md="12"> -->
                        <b-row>
                          <b-col sm="12" lg="6">
                            <b-row>
                              <b-col sm="6">
                                <Callout variant="info">
                                  <small class="text-muted">New Clients</small>
                                <br />
                                <strong class="h4">9,123</strong>
                                  <div class="chart-wrapper" :style="{ top: '-10px'}">
                                  <!--<callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#20a8d8" width="80" height="30" />-->
                                    <callout-chart-example
                                      chartId="callout-chart-01"
                                      :data="[35, 23, 56, 22, 97, 23, 64]"
                                      variant="info"
                                      width="80"
                                      height="30"
                                    />
                                  </div>
                               </Callout>
                              </b-col>
                          <b-col sm="6">
                            <Callout variant="danger">
                              <small class="text-muted">Recurring Clients</small>
                              <br />
                                <strong class="h4">22,643</strong>
                                  <div class="chart-wrapper" :style="{ top: '-10px'}">
                                    <callout-chart-example
                                      chartId="callout-chart-02"
                                      :data="[65, 59, 84, 84, 51, 55, 40]"
                                      variant="danger"
                                      width="80"
                                      height="30"
                                    />
                                  </div>
                            </Callout>
                          </b-col>
                        </b-row>
                        <hr class="mt-0" />
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Monday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress class="progress-xs" variant="info" :value="34" height="{}" />
                              <b-progress class="progress-xs" variant="danger" :value="78" height="{}" />
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Tuesday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="56" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="94" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Wednesday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="12" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="67" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Thursday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="43" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="91" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Friday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="22" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="73" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Saturday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="53" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="82" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="progress-group mb-4">
                            <div class="progress-group-prepend">
                              <span class="progress-group-text">Sunday</span>
                            </div>
                            <div class="progress-group-bars">
                              <b-progress height="{}" class="progress-xs" :value="9" variant="info"></b-progress>
                              <b-progress height="{}" class="progress-xs" :value="69" variant="danger"></b-progress>
                            </div>
                          </div>
                          <div class="legend text-center">
                            <small>
                            <sup>
                              <b-badge pill variant="info">&nbsp;</b-badge>
                            </sup>
                             New clients
                             &nbsp;&nbsp;
                            <sup>
                              <b-badge pill variant="danger">&nbsp;</b-badge>
                            </sup>
                             Recurring clients
                            </small>
                          </div>
                        </b-col>
                        <b-col sm="12" lg="6">
                          <b-row>
                            <b-col sm="6">
                              <Callout variant="warning">
                                <small class="text-muted">Pageviews</small>
                                  <br />
                                    <strong class="h4">78,623</strong>
                                      <div class="chart-wrapper" :style="{ top: '-10px'}">
                                        <callout-chart-example
                                          chartId="callout-chart-03"
                                          :data="[35, 23, 56, 22, 97, 23, 64]"
                                          variant="#f8cb00"
                                          width="80"
                                          height="30"
                                        />
                                      </div>
                              </Callout>
                            </b-col>
                        <b-col sm="6">
                    <Callout variant="success">
                      <small class="text-muted">Organic</small>
                      <br />
                      <strong class="h4">49,123</strong>
                      <div class="chart-wrapper" :style="{ top: '-10px'}">
                        <callout-chart-example
                          chartId="callout-chart-04"
                          :data="[65, 59, 84, 84, 51, 55, 40]"
                          variant="#4dbd74"
                          width="80"
                          height="30"
                        />
                      </div>
                    </Callout>
                    </b-col>
                </b-row>
                <hr class="mt-0" />
                <ul class="horizontal-bars type-2">
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <i class="icon-user progress-group-icon"></i>
                      <span class="title">Male</span>
                      <span class="ml-auto font-weight-bold">43%</span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="43" variant="warning"></b-progress>
                    </div>
                  </div>
                  <div class="progress-group mb-5">
                    <div class="progress-group-header">
                      <i class="icon-user-female progress-group-icon"></i>
                      <span class="title">Female</span>
                      <span class="ml-auto font-weight-bold">37%</span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="37" variant="warning"></b-progress>
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <i class="icon-globe progress-group-icon"></i>
                      <span class="title">Organic Search</span>
                      <span class="ml-auto font-weight-bold">
                        191,235
                        <span class="text-muted small">(56%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="56" variant="success"></b-progress>
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <i class="icon-social-facebook progress-group-icon"></i>
                      <span class="title">Facebook</span>
                      <span class="ml-auto font-weight-bold">
                        51,223
                        <span class="text-muted small">(15%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="15" variant="success"></b-progress>
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <i class="icon-social-twitter progress-group-icon"></i>
                      <span class="title">Twitter</span>
                      <span class="ml-auto font-weight-bold">
                        37,564
                        <span class="text-muted small">(11%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="11" variant="success"></b-progress>
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <i class="icon-social-linkedin progress-group-icon"></i>
                      <span class="title">LinkedIn</span>
                      <span class="ml-auto font-weight-bold">
                        27,319
                        <span class="text-muted small">&nbsp;(8%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <b-progress height="{}" class="progress-xs" :value="8" variant="success"></b-progress>
                    </div>
                  </div>
                  <div class="divider text-center">
                    <b-button variant="link" size="sm" class="text-muted">
                      <i class="icon-options"></i>
                    </b-button>
                  </div>
                </ul>
                  </b-col>
                </b-row>
            </b-card-body>
          </b-card>
        </b-container>
                  </b-row>
              </div>    
            </div>
          </b-col>

          <b-col class="col-md-12 component-section">
            <div class="panel panel-default">
              <div class="panel">
                <!-- 16 -->
                <!-- Table -->
      <b-row class="row">
        <b-container class="column component-section">
          <b-card no-body class="panel panel-default panel-body">
            <b-card-body class="panel clearfix">
              <b-table 
                class="mb-0 table-outline column"
                responsive="sm"
                hover
                :items="tableItems"
                head-variant="light"
              >
              <div slot="avatar" class="avatar" slot-scope="item">
                <img :src="item.value.url" class="img-avatar" alt />
                  <span
                    class="avatar-status"
                    v-bind:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"
                  ></span>
              </div>
              <div slot="user" slot-scope="item">
            <div>{{item.value.name}}</div>
            <div class="small text-muted">
              <span>
                <template v-if="item.value.new">New</template>
                <template v-else>Recurring</template>
              </span>
              | Registered: {{item.value.registered}}
            </div>
          </div>
          <i
            slot="country"
            class="h4 mb-0"
            :class="flag(item.value.flag)"
            slot-scope="item"
            :title="item.value.flag"
            :id="item.value.flag"
          ></i>
          <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
          <div slot="usage" slot-scope="item">
            <div class="clearfix">
              <div class="float-left">
                <strong>{{item.value.value}}%</strong>
              </div>
              <div class="float-right">
                <small class="text-muted">{{item.value.period}}</small>
              </div>
            </div>
            <b-progress
              height="{}"
              class="progress-xs"
              v-model="item.value.value"
              :variant="variant(item.value.value)"
            ></b-progress>
          </div>
          <i slot="payment" slot-scope="item" :class="item.value.icon" style="font-size:24px"></i>
          <div slot="activity" slot-scope="item">
            <div class="small text-muted">Last login</div>
            <strong>{{item.value}}</strong>
          </div>
        </b-table>
        </b-card-body>
          </b-card>
        </b-container>
      </b-row>
              </div>    
            </div>
          </b-col>
        </div>
      </div> <!--class="row component-container"-->
    </div>
</template>

<script>
import Vue from "vue";
import CardLine1ChartExample from "./dashboard/CardLine1ChartExample";
import CardLine2ChartExample from "./dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "./dashboard/CardLine3ChartExample";
import CardBarChartExample from "./dashboard/CardBarChartExample";
import MainChartExample from "./dashboard/MainChartExample";
import PieExample from "./dashboard/PieExample";
import SocialBoxChartExample from "./dashboard/SocialBoxChartExample";
import CalloutChartExample from "./dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import * as VueGridLayout from "vue-grid-layout";
import defaultLayouts from "./dashboard/_layouts";
import VueMq from "vue-mq";
import { ResizeObserver } from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import Page403 from "@/views/pages/Page403.vue";
import { router } from '@/router/index';

// Map Chart
import HighchartsVue from "highcharts-vue";
import MapChart from "./dashboard/MapChart";

Vue.use(HighchartsVue);

import { ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

const GridLayout = VueGridLayout.GridLayout;
const GridItem = VueGridLayout.GridItem;
const breakpoints = {
  xs: 575,
  sm: 767,
  md: 991,
  lg: 1199,
  xl: Infinity
};
const gridCols = { xs: 1, sm: 2, md: 3, lg: 3, xl: 3 };
const localStorageKey = "CoreUI-Vue-Draggable-Layouts";

Vue.use(VueMq, { breakpoints, defaultBreakpoint: "xs" });
Vue.component("resize-observer", ResizeObserver);

export default {
  name: "dashboard",
  components: {
    ClientTable,
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    PieExample,
    CalloutChartExample,
    mapChart: MapChart,
    highcharts: Chart,
    GridLayout,
    GridItem,
    Page403
  },
  data: function() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      isLoading: true,
      defaultLayout: [],
      selected: "Month",
      topLists: [
        { title: "United States", clients: "7" },
        { title: "Canada", clients: "1" }
      ],
      tableItems: [
        {
          avatar: { url: "/img/avatars/1.jpg", status: "success" },
          user: {
            name: "Yiorgos Avraamu",
            new: true,
            registered: "Jan 1, 2015"
          },
          country: { name: "USA", flag: "us" },
          usage: { value: 50, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Mastercard", icon: "fa fa-cc-mastercard" },
          activity: "10 sec ago"
        },
        {
          avatar: { url: "/img/avatars/2.jpg", status: "danger" },
          user: {
            name: "Avram Tarasios",
            new: false,
            registered: "Jan 1, 2015"
          },
          country: { name: "Brazil", flag: "br" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Visa", icon: "fa fa-cc-visa" },
          activity: "5 minutes ago"
        },
        {
          avatar: { url: "/img/avatars/3.jpg", status: "warning" },
          user: { name: "Quintin Ed", new: true, registered: "Jan 1, 2015" },
          country: { name: "India", flag: "in" },
          usage: { value: 74, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Stripe", icon: "fa fa-cc-stripe" },
          activity: "1 hour ago"
        },
        {
          avatar: { url: "/img/avatars/4.jpg", status: "" },
          user: { name: "Enéas Kwadwo", new: true, registered: "Jan 1, 2015" },
          country: { name: "France", flag: "fr" },
          usage: { value: 98, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "PayPal", icon: "fa fa-paypal" },
          activity: "Last month"
        },
        {
          avatar: { url: "/img/avatars/5.jpg", status: "success" },
          user: {
            name: "Agapetus Tadeáš",
            new: true,
            registered: "Jan 1, 2015"
          },
          country: { name: "Spain", flag: "es" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Google Wallet", icon: "fa fa-google-object" },
          activity: "Last week"
        },
        {
          avatar: { url: "/img/avatars/6.jpg", status: "danger" },
          user: {
            name: "Friderik Dávid",
            new: true,
            registered: "Jan 1, 2015"
          },
          country: { name: "Poland", flag: "pl" },
          usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Amex", icon: "fa fa-cc-amex" },
          activity: "Last week"
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="fa fa-user"></i>',
          class: "text-center"
        },
        user: {
          label: "User"
        },
        country: {
          label: "Country",
          class: "text-center"
        },
        usage: {
          label: "Usage"
        },
        payment: {
          label: "Payment method",
          class: "text-center"
        },
        activity: {
          label: "Activity"
        }
      },
      layouts: JSON.parse(
        localStorage.getItem(localStorageKey) || JSON.stringify(defaultLayouts)
      ),
      gridCols: gridCols,
      margin: [10, 10],
      rowHeight: 1
    };
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = "info";
      } else if (value > 25 && value <= 50) {
        $variant = "success";
      } else if (value > 50 && value <= 75) {
        $variant = "warning";
      } else if (value > 75 && value <= 100) {
        $variant = "danger";
      }
      return $variant;
    },
    flag(value) {
      return "flag-icon flag-icon-" + value;
    }
  },
  mounted: function() {
    let that = this;
    that.getPermission();
    if(!that.permission.capabilities.View){
      that.showPage403 = true;
      return;
    }

    this.data = [];
    this.data = [
      {
        title: "United States",
        clients: "7",
        id: 0
      }
    ];
    $(document).ready(function() {
      $('.component-container').sortable({
       cursor: 'move',
       placeholder: 'ui-state-highlight',
       start: function(e, ui) {
        ui.placeholder.width(ui.item.find('.panel').width());
        ui.placeholder.height(ui.item.find('.panel').height());
        ui.placeholder.addClass(ui.item.attr("class"));
    }
  });
});
  }
};
</script>

<style scoped>
body{
  display: flex !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.custom-header {
  display: block;
}
.col-sm-4, .col-sm-8  {
  margin-left: 0 !important;
  margin-right: 0 !important;
  float: left;
  padding: 0px 0px;
}

div#pieChart.column.col-sm-3{
  padding: 0px 2px;
}

.block-placeholder {
  background: #DADADA;
  position: relative;
}

.block-placeholder:after {
  content: " ";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 15px;
  background-color: #FFF;
}

div.btn-toolbar.float-right{
  margin: 0 0 0 0;
}

div#pieChart.column.col-sm-12, div.col.column.component-section, div.col4.component-section.col.ui-sortable-handle, div.col-4.component-section.col.ui-sortable-handle, div.col-12, div.animated.fadeIn.content-holder.container{
  padding: 0 5px;
}

.textPieChart{
  max-width: 18rem;
}

@media (max-width: 767px){
.col-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 30%;
    flex: 0 0 7%;
    max-width: 25% !important;
    }
.chart-btn {
    width: 100%;
    height: 67%;
    font-size: 12px;
    }
h4.mb-0{
    font-size: 15px;
    }
canvas#card-chart-04.chartjs-render-monitor, canvas#card-chart-03.chartjs-render-monitor, canvas#card-chart-02.chartjs-render-monitor, canvas#card-chart-01.chartjs-render-monitor{
    display: block;
    height: 30px !important;
    width: 85px !important;
    }
div.card-body{
    padding: 20px 10px 10px;
    }
#topLists, #emailsSent{
    font-size: 13px;
    }
div.card.textPieChart{
   width: 130px;
   font-size: 10px;
   }
}
@media (min-width: 1200px){
.container {
    max-width: 1080px !important;
    }
}
</style>
